import React, { type FC } from "react";
import { type UscEcoType, aemEcoLabelMap } from "../../../../../../../shared-logic/utils/uscEcoUtils";
import { useUscSelector } from "../../../../../../redux/store";
import { useUscOptionalLabel } from "../../../../../../utils/labels";
import * as EcoLabelStyles from "../../../../../../../../common-deprecated/styles/v2/lexus/components/EcoLabel";

const EcoLabelImage: FC<{ ecoInfo: UscEcoType }> = ({ ecoInfo }) => {
    const uscSettings = useUscSelector((state) => state.uscSettings);
    const [descriptionLabel, disclaimerLabel] = useUscOptionalLabel([
        "uscPdpSpecEcoImageDescription",
        "uscPdpSpecEcoImageDisclaimer",
    ]);

    const ecoLabelImage =
        ecoInfo.efficiencyClass?.code && uscSettings.ecoLabels
            ? uscSettings.ecoLabels.images[aemEcoLabelMap[ecoInfo.efficiencyClass?.code]]
            : null;

    if (!ecoLabelImage) return null;

    return (
        <EcoLabelStyles.EcoWrapper>
            {descriptionLabel && (
                <EcoLabelStyles.EcoImageDescription>{descriptionLabel}</EcoLabelStyles.EcoImageDescription>
            )}
            <EcoLabelStyles.EcoImage src={ecoLabelImage} alt={ecoInfo.efficiencyClass?.description} />
            {disclaimerLabel && <EcoLabelStyles.EcoDisclaimer>{disclaimerLabel}</EcoLabelStyles.EcoDisclaimer>}
        </EcoLabelStyles.EcoWrapper>
    );
};

export default EcoLabelImage;
